import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {labels} from '../../../../util/utils';
import {advancedFiltersIcon} from '../../../../util/svgIcons';
import {setOrgChart} from '../../../../actions/Project/orgStructureAction';

import Button from '../../../CoreWrappers/Button';
import FiltersModal from './FiltersModal';

const AdvancedFiltersModal = () => {
	const dispatch = useDispatch();
	const [showModal, setShowModal] = useState(false);
	const orgChart = useSelector((store) => store.orgChart);
	const ents = useSelector((store) => store.dashboardContext.entities);

	const handlerOnOkClick = (entities) => {
		dispatch(setOrgChart(entities));
		setShowModal(false);
	};

	const handlerOnHide = () => {
		setShowModal(false);
	};

	const renderTrigger = () => {
		const props = {
			svg: advancedFiltersIcon,
			label: labels.advancedFilters,
			onClick: () => setShowModal(true),
			variant: 'text'
		};

		return <Button {...props} />;
	};

	return (
		<>
			{renderTrigger()}
			{showModal && (
				<FiltersModal
					orgChart={orgChart}
					selectedEntities={ents}
					showModal={showModal}
					onModalOk={handlerOnOkClick}
					onModalHide={handlerOnHide}
					modalTitle={labels.advancedFilters}
					primaryButtonLabel={labels.applyFilters}
					secondaryButtonLabel={labels.cancelLabel}
					auxiliaryButtonLabel={''}
					instructionalHeader={labels.advancedFiltersInstructionalText}
					instructionalText={labels.advancedFiltersInstructionalTextLine2}
				/>
			)}
		</>
	);
};

export default AdvancedFiltersModal;
